fetch('/env.json')
  .then((response) => response.json())
  .then((data) => {
    window.FETCHED_ENV_DATA = data;
    // change public path for dynamic imports
    __webpack_public_path__ = data.STATIC_PATH || '/';
  })
  .catch((error) => {
    console.error('There is no env.json:', error);
  })
  .finally(() => {
    let attemptCount = 0;

    const loadChunk = () => {
      import(/* webpackChunkName: "app" */ '#index').catch((error) => {
        console.error(error);
        attemptCount++;
        if (attemptCount < 3) {
          setTimeout(loadChunk, 3000);
        }
      });
    };

    loadChunk();
  });
